import { render, staticRenderFns } from "./MSTeamsPresenting.vue?vue&type=template&id=33589d38"
import script from "./MSTeamsPresenting.vue?vue&type=script&lang=js"
export * from "./MSTeamsPresenting.vue?vue&type=script&lang=js"
import style0 from "./MSTeamsPresenting.vue?vue&type=style&index=0&id=33589d38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports